// css
import "./blogs.css"
// others
import mainBlogImg from "assets/Images/bg/mainBlog.png";
import shareImg from "assets/Images/icons/share.svg";
import LikeImg from "Utills/LikeImg";
import React from "react";
import blog2 from "assets/Images/blogs/blog2.png";
import blog3 from "assets/Images/blogs/blog3.png";
import blog4 from "assets/Images/blogs/blog4.png";
import blog5 from "assets/Images/blogs/blog5.png";
import blog6 from "assets/Images/blogs/blog6.png";
import blog7 from "assets/Images/blogs/blog7.png";
import blog8 from "assets/Images/blogs/blog8.png";

// =====================  THis is a blog page ========================
const Blogs = () => {
    // All blogs data (static)
    let allBlogs = [
        { title: "Never book alone!", bodyText: "You must sell. If you're selling a business because profits are shrinking, this is going. spent a great deal of time and effort to find the right oneIt's easy to get emotional about selling your...", img: blog2, likes: 256, date: 'Oct 25th, 2021' },
        { title: "Get your stuff ready before the sailing", bodyText: "You must sell. If you're selling a business because profits are shrinking, this is going. spent a great deal of time and effort to find the right oneIt's easy to get emotional about selling your...", img: blog3, likes: 256, date: 'Oct 25th, 2021' },
        { title: "Why should i stay far from beach?", bodyText: "You must sell. If you're selling a business because profits are shrinking, this is going. spent a great deal of time and effort to find the right oneIt's easy to get emotional about selling your...", img: blog4, likes: 256, date: 'Oct 25th, 2021' },
        { title: "How should i compare Yachts?", bodyText: "You must sell. If you're selling a business because profits are shrinking, this is going. spent a great deal of time and effort to find the right oneIt's easy to get emotional about selling your...", img: blog5, likes: 256, date: 'Oct 25th, 2021' },
        { title: "Get the perfect view in Yacht", bodyText: "You must sell. If you're selling a business because profits are shrinking, this is going. spent a great deal of time and effort to find the right oneIt's easy to get emotional about selling your...", img: blog6, likes: 256, date: 'Oct 25th, 2021' },
        { title: "Stay seen", bodyText: "You must sell. If you're selling a business because profits are shrinking, this is going. spent a great deal of time and effort to find the right oneIt's easy to get emotional about selling your...", img: blog7, likes: 256, date: 'Oct 25th, 2021' },
        { title: "Should you park the Yacht?", bodyText: "You must sell. If you're selling a business because profits are shrinking, this is going. spent a great deal of time and effort to find the right oneIt's easy to get emotional about selling your...", img: blog8, likes: 256, date: 'Oct 25th, 2021' },
    ];
    return (
        <div className="blogs-page mb-md-5 mb-3">
            <div className="row">
                <div className="blog-page-left-col">
                    <div className="main-blog-wrapper">
                        <img className="main-blog-img" src={mainBlogImg} alt="cyan booking" />
                        <div className="main-post-bottom-card">
                            <div className="post-card-title">
                                <h4>Choose the right timing for sailing</h4>
                            </div>
                            <div className="post-card-bodyText">
                                The most important factor when it comes to timing is to not wait until you must sell. If you're selling a business because profits are shrinking, this is going. spent a great deal of time and effort to find the right oneIt's easy to get emotional about selling your... <button className="continue-btn text-sec">Continue Reading below</button>
                            </div>
                            <div className="post-card-footer py-2 text-muted d-flex justify-content-between align-items-center">
                                <button className="d-flex justify-content-center align-items-center likee-btn">
                                    <LikeImg liked={true} />
                                    <span className="text-sec">256</span>
                                </button>
                                <div className="post-card-date">
                                    <span>Oct 25th, 2021</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="main-blog-content">
                        <h1>Choose the right timing for sailing</h1>
                        <p>
                            Getting ready to plan a sailboat charter trip and wondering what the best time to sail is? Whether it’s your first time sailing and setting out to sea or you’re a seasoned sailor looking to chart a new course, the same adage holds true: When it comes to sailing seasons around the world, timing is everything.
                        </p>
                        <p>
                            For the best sailing conditions, ideal yacht charter prices, and overall travel experience, it’s important to know when it’s considered sailing “primetime” around the world.
                        </p>
                        <p>
                            How do you know where to sail, and when?
                        </p>
                        <p>
                            We’re breaking down when to set sail in the Caribbean, the Exotics, Europe, and the U.S., so you can mark your calendar and plan your trip for your best getaway yet.
                        </p>
                        <p>
                            Let's dive in...
                        </p>
                        <p>
                            With warm weather year-round, the Caribbean is one of the most popular landscapes for an idyllic sailing holiday. Peak season is between December and April, when temperatures average between 73F (23C) and 83F (28C), setting the scene for great sailing conditions.
                        </p>
                        <p>
                            For example, in the British Virgin Islands (BVIs), the winter’s moderate temperature and winds make it an ideal time for tourists.
                        </p>
                        <p>
                            But if you’re hoping to avoid some of the crowds and the hike in holiday pricing, you can consider sailing during the shoulder season in May or June. With June winds averaging 10-15 knots from the southeast and weather warming up to an average of 84F (28C), you can get the best of the islands without the tourist frenzy, making early summer perhaps the best time to sail in the BVIs.
                        </p>
                        <p>
                            Similarly, you’ll find that the Bahamas is at its busiest from December to February, when the average temperature of 70-75F (21-24C) is a refreshing break for tourists escaping warm weather. But if your real aim is to escape the tourists, don’t worry:
                        </p>
                        <p>
                            You’re not out of luck! With 340 sunny days in the year, the islands maintain a warm climate year-round with little rainfall to ruin your sailing plans. As long as you’re cautious around hurricane season (from July to November), you’ll find the best time to sail in the Bahamas to avoid tourists in spring, from March to May.
                        </p>
                        <p>
                            Antigua is another ideal getaway in the Caribbean and one of the world’s most favorable for sailing. With 54 miles of Caribbean coastline, Antigua boasts an impressive 365 beaches, so you have no limits to your yachting adventures.
                        </p>
                        <p>
                            And with year-round desirable conditions, you can’t go wrong with a holiday in Antigua; throughout the year, temperatures average between 77F (25 C) and 88F (31 C), trade winds remain steady, and the tidal range is small, between 12 and 18 inches.
                        </p>
                        <p>
                            But when is the best time to sail in Antigua? Peak season is December to April - the perfect time for a warm getaway if you’re looking to escape the cold weather in the U.S. or Europe. For fewer tourists and lower prices, sailing during the shoulder season (in May or June) is a good option, too.
                        </p>
                        <div className="d-flex justify-content-end my-3"><span className="">Oct 25th, 2021</span></div>
                        <hr className="bg-dark"/>
                        <div className="d-flex mb-md-5 mb-3 pt-2 flex-wrap justify-content-md-between justify-content-center align-items-center">
                            <h2>Was it useful for you?</h2>
                            <div className="py-3">
                                <button className="likee-btn text-sec px-2"><LikeImg /> <span>Like</span></button>
                                <button className="likee-btn text-sec mx-4"><img src={shareImg} alt="" /> Share</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="blog-page-right-col mb-5">
                    <h2>12 Blogs help you to enjoy your sailing </h2>
                    <p className="text-muted my-2">Our blogs are relastic and have been gathered from expert captains through interviews, Scientific studies and previous expertises</p>
                    <hr className="mb-5 bg-secondary" />
                    {allBlogs.map((data, index) => (
                        <React.Fragment key={index}>
                            <SmallBlogCard data={data} />
                            {allBlogs.length - 1 === index ? null : <div className="cs-hr"></div>}
                        </React.Fragment>
                    ))
                    }
                </div>
            </div>
        </div>
    )
};


//==========================  relevant blogs card =======================
const SmallBlogCard = ({ data }) => {
    return (
        <div className="small-blog-card">
            <div className="blog-card-top">
                <div className="post-card-body-img">
                    <div className="sm-card-img">
                        <img src={data?.img} alt="cyan Booking" />

                    </div>
                </div>
                <div className="small-card-right-col">
                    <div className="post-card-title">
                        <h4>{data.title}</h4>
                    </div>
                    <div className="post-card-bodyText">
                        <p>
                            {data?.bodyText}

                        <button className="continue-btn text-sec">Read more</button>
                        </p>
                    </div>
                </div>

            </div>
            <div className="post-card-footer py-2 text-muted d-flex justify-content-between align-items-center">
                <button className="d-flex justify-content-center align-items-center likee-btn">
                    <LikeImg liked={true} />
                    <span className="text-sec">{data?.likes}</span>
                </button>
                <div className="post-card-date">
                    <span>{data?.date}</span>
                </div>
            </div>
        </div>
    )
};

export default Blogs;
